module.exports = __webpack_public_path__ + "img/gestures_en.552380d.jpg";